<template>
    <div class="h-100 p-2" v-if='this.item.user1'>
        <!-- <h4 class='section-heading'>Duplicate Patient Details <span v-if='this.$parent.event == "staff"' class="small float-right">See also Settings > Groups  to ensure correct membership</span></h4> -->

        <table class='table table-full-border table__duplicate'>
            <tr>
                <th>&nbsp;</th>
                <th><button v-if='$root.user.provider.id' class="btn btn-light btn-sm btn-round mr-auto" v-on:click.prevent="openEditA">{{ tBrandKey('client') | capitalise }} A</button></th>
                <th><button v-if='$root.user.provider.id' class="btn btn-light btn-sm btn-round mr-auto" v-on:click.prevent="openEditB">{{ tBrandKey('client') | capitalise }} B</button></th>
            </tr>
            <tr :class='this.diff(this.item.user1.last_login, this.item.user2.last_login)'>
                <th>{{ $t('translations.account_status')}}</th>
                <td>{{this.item.user1.last_login ? "Active: Last logged in: " + formatDateTime(this.item.user1.last_login) : autobrand('translations.patient_never_logged_in')}}</td>
                <!-- <td><input type='text' v-bind='data.last_login'></td> -->
                <td>{{this.item.user2.last_login ? "Active: Last logged in: " + formatDateTime(this.item.user2.last_login) : autobrand('translations.patient_never_logged_in')}}</td>
            </tr>
            <tr :class='this.diff(this.item.user1.user_title_id, this.item.user2.user_title_id)'>
                <th>{{ $t('translations.title')}}</th>
                <td>{{this.item.user1.user_title ? this.item.user1.user_title.name : ""}}</td>
                <td>{{this.item.user2.user_title ? this.item.user2.user_title.name : ""}}</td>
            </tr>
            <tr :class='this.diff(this.item.user1.forenames.toLowerCase(), this.item.user2.forenames.toLowerCase())'>
                <th>{{ $t('translations.forenames')}}</th>
                <td>{{this.item.user1.forenames}}</td>
                <td>{{this.item.user2.forenames}}</td>
            </tr>
            <tr :class='this.diff(this.item.user1.surname.toLowerCase(), this.item.user2.surname.toLowerCase())'>
                <th>{{ $t('translations.surname')}}</th>
                <td>{{this.item.user1.surname}}</td>
                <td>{{this.item.user2.surname}}</td>
            </tr>
            <tr :class='this.diff(this.item.user1.verification_status_id, this.item.user2.verification_status_id)'>
                <th>{{ $t('translations.IDStatus')}}</th>
                <td>{{$root.lookup.verification_statuses[this.item.user1.verification_status_id]}}</td>
                <td>{{$root.lookup.verification_statuses[this.item.user2.verification_status_id]}}</td>
            </tr>
            <tr :class='this.diff(this.item.user1.email, this.item.user2.email)'>
                <th>{{ $t('translations.email')}}</th>
                <td>{{this.item.user1.email}}</td>
                <td>{{this.item.user2.email}}</td>
            </tr>
            <tr :class='this.diff(this.item.user1.dob, this.item.user2.dob)'>
                <th>{{ $t('translations.date_of_birth')}}</th>
                <td>{{this.item.user1.dob | formatDate}}</td>
                <td>{{this.item.user2.dob | formatDate}}</td>
            </tr>
            <tr :class='this.diff(this.item.user1.gender, this.item.user2.gender)'>
                <th>{{ $t('translations.gender')}}</th>
                <td>{{getGender(this.item.user1.gender)}}</td>
                <td>{{getGender(this.item.user2.gender)}}</td>
            </tr>
            <tr :class='this.diff(this.item.user1.preferred_clinician, this.item.user2.preferred_clinician)'>
                <th>{{ $t('translations.usual_GP')}}</th>
                <td>{{formatNameCompliant(this.item.user1.preferred_clinician)}}</td>
                <td>{{formatNameCompliant(this.item.user2.preferred_clinician)}}</td>
            </tr>
            <tr :class='this.diff(this.item.user1.site_id, this.item.user2.site_id)'>
                <th>{{ $t('translations.preferred_site')}}</th>
                <td>{{this.getSiteName(this.item.user1)}}</td>
                <td>{{this.getSiteName(this.item.user2)}}</td>
            </tr>
            <tr :class='this.diff(this.item.user1.phone_number, this.item.user2.phone_number)'>
                <th>{{ $t('translations.telephone_number')}}</th>
                <td>{{this.item.user1.phone_number}}</td>
                <td>{{this.item.user2.phone_number}}</td>
            </tr>
            <tr :class='this.diff(this.item.user1.phone_number_alt, this.item.user2.phone_number_alt)'>
                <th>{{ $t('translations.alternative_telephone')}}</th>
                <td>{{this.item.user1.phone_number_alt}}</td>
                <td>{{this.item.user2.phone_number_alt}}</td>
            </tr>
            <tr :class='this.diff(this.item.user1.nhs_number, this.item.user2.nhs_number)'>
                <th>{{ $t('translations.NHS_number')}}</th>
                <td>{{this.item.user1.nhs_number | formatNhsNumber}}</td>
                <td>{{this.item.user2.nhs_number | formatNhsNumber}}</td>
            </tr>
            <tr :class='this.diff(this.item.user1.address_line_1, this.item.user2.address_line_1)'>
                <th>{{ $t('translations.address_line_1')}}</th>
                <td>{{this.item.user1.address_line_1}}</td>
                <td>{{this.item.user2.address_line_1}}</td>
            </tr>
            <tr :class='this.diff(this.item.user1.address_line_2, this.item.user2.address_line_2)'>
                <th>{{ $t('translations.address_line_2')}}</th>
                <td>{{this.item.user1.address_line_2}}</td>
                <td>{{this.item.user2.address_line_2}}</td>
            </tr>
            <tr :class='this.diff(this.item.user1.address_line_3, this.item.user2.address_line_3)'>
                <th>{{ $t('translations.address_line_3')}}</th>
                <td>{{this.item.user1.address_line_3}}</td>
                <td>{{this.item.user2.address_line_3}}</td>
            </tr>
            <tr :class='this.diff(this.item.user1.address_line_4, this.item.user2.address_line_4)'>
                <th>{{ $t('translations.address_line_4')}}</th>
                <td>{{this.item.user1.address_line_4}}</td>
                <td>{{this.item.user2.address_line_4}}</td>
            </tr>
            <tr :class='this.diff(this.item.user1.postcode, this.item.user2.postcode)'>
                <th>{{ $t('translations.postcode')}}</th>
                <td>{{this.item.user1.postcode}}</td>
                <td>{{this.item.user2.postcode}}</td>
            </tr>
            <tr :class='this.diff(JSON.stringify(this.item.user1.carees), JSON.stringify(this.item.user2.carees))'>
                <th>{{ tBrand('is_proxy_for') }}</th>
                <td>
                    <template v-if='this.item.user1.carees && this.item.user1.carees.length > 0'>
                        <ul class="list-group">
                            <li :key='relationship.id' class="list-group-item" v-for='relationship in this.item.user1.carees'>{{formatNameCompliant(relationship)}} ({{$root.lookup.user_relationship_types[relationship.user_relationship_type_id]}})</li>
                        </ul>
                    </template>
                    <template v-else>{{ $t('translations.none_listed')}}</template>
                </td>
                <td>
                    <template v-if='this.item.user2.carees && this.item.user2.carees.length > 0'>
                        <ul class="list-group">
                            <li :key='relationship.id' class="list-group-item" v-for='relationship in this.item.user2.carees'>{{formatNameCompliant(relationship)}} ({{$root.lookup.user_relationship_types[relationship.user_relationship_type_id]}})</li>
                        </ul>
                    </template>
                    <template v-else>{{ $t('translations.none_listed')}}</template>
                </td>
            </tr>
            <tr :class='this.diff(JSON.stringify(this.item.user1.carers), JSON.stringify(this.item.user2.carers))'>
                <th>{{ $t('translations.in_care_of')}}</th>
                <td>
                    <template v-if='this.item.user1.carers && this.item.user1.carers.length > 0'>
                        <ul class="list-group">
                            <li :key='relationship.id' class="list-group-item" v-for='relationship in this.item.user1.carers'>{{formatNameCompliant(relationship)}} ({{$root.lookup.user_relationship_types[relationship.user_relationship_type_id]}})</li>
                        </ul>
                    </template>
                    <template v-else>{{ $t('translations.none_listed')}}</template>
                </td>
                <td>
                    <template v-if='this.item.user2.carers && this.item.user2.carers.length > 0'>
                        <ul class="list-group">
                            <li :key='relationship.id' class="list-group-item" v-for='relationship in this.item.user2.carers'>{{formatNameCompliant(relationship)}} ({{$root.lookup.user_relationship_types[relationship.user_relationship_type_id]}})</li>
                        </ul>
                    </template>
                    <template v-else>{{ $t('translations.none_listed')}}</template>
                </td>
            </tr>
            <tr :class='rtl_diff' class='h-100'>
                <th>{{ autobrand('translations.previous_requests')}}</th>
                <td class="table__duplicate--prev-request">
                    <related-thread-list
                        v-if = 'item'
                        modalid="related-thread-filter-modal"
                        displayelement = "thread-list"
                        event = "thread"
                        model =  "thread"
                        title = "Requests"
                        path = 'threads'
                        route = '/api/v1/threads'
                        :user = 'this.item.user1'
                        ref='user1_rtl'
                        v-on:loaded='rtl_loaded++'>
                    </related-thread-list>
                </td>
                <td class="table__duplicate--prev-request">
                    <related-thread-list
                        v-if = 'item'
                        modalid="related-thread2-filter-modal"
                        displayelement = "thread-list"
                        event = "thread"
                        model =  "thread"
                        title = "Requests"
                        path = 'threads'
                        route = '/api/v1/threads'
                        :user = 'this.item.user2'
                        ref='user2_rtl'
                        v-on:loaded='rtl_loaded++'>
                    </related-thread-list>
                </td>
            </tr>
        </table>

        <div class='pb-2'>
            <div class='alert alert-info'>
                <p class='h4'><strong>{{ $t('translations.considerations')}}</strong></p>
                {{ autobrand('translations.consider_the_following_before_merging')}}:
                <ul>
                    <template v-if='item.user1.last_login || item.user2.last_login'>
                        <li v-if='item.user1.last_login && item.user2.last_login'>{{autobrand('translations.both_patient_accounts_active_and_logged_in')}}</li>
                        <li v-else-if='item.user1.last_login'>{{autobrand('translations.patient_A_active_used_by_patient_to_login')}}</li>
                        <li v-else-if='item.user2.last_login'>{{autobrand('translations.patient_B_active_used_by_patient_to_login')}}</li>
                    </template>

                    <template v-else>
                        <li v-if='item.user1.email && item.user2.email'>{{autobrand('translations.both_patient_accounts_email_set_neither_logged_in')}}</li>
                        <li v-else-if='item.user1.email && !item.user2.email'>{{autobrand('translations.patient_A_email_set_not_logged_in')}}</li>
                        <li v-if='!item.user1.email && item.user2.email'>{{autobrand('translations.patient_B_email_set_not_logged_in')}}</li>
                        <li v-if='!item.user1.email && !item.user2.email'>{{autobrand('translations.neither_account_has_email')}}</li>
                    </template>

                    <template v-if='item.user1.nhs_number != item.user2.nhs_number'>
                        <li v-if='item.user1.nhs_number'>{{autobrand('translations.patient_A_has_NHS_CHI_number')}}</li>
                        <li v-else-if='item.user2.nhs_number'>{{autobrand('translations.patient_B_has_NHS_CHI_number')}}</li>
                    </template>

                    <li v-if='item.user1.verification_status_id != item.user2.verification_status_id'>{{autobrand('translations.verification_statuses_of_patients_different')}}</li>

                    <li v-if='user_1_has_rtl && user_2_has_rtl'>{{autobrand('translations.both_patients_have_requests_all_will_assign_to_chosen_patient')}}</li>
                    <li v-else-if='user_1_has_rtl'>{{autobrand('translations.patient_A_has_requests')}}</li>
                    <li v-else-if='user_2_has_rtl'>{{autobrand('translations.patient_B_has_requests')}}</li>

                    <li v-if='this.item.user1.carers && this.item.user1.carers.length > 0 && this.item.user2.carers && this.item.user2.carers.length > 0'>{{autobrand('translations.both_patients_have_carers_all_will_be_assigned_to_chosen_patient')}}</li>
                    <li v-else-if='this.item.user1.carers && this.item.user1.carers.length > 0'>{{autobrand('translations.patient_A_has_carers_those_will_be_copied_to_chosen_patient')}}</li>
                    <li v-else-if='this.item.user2.carers && this.item.user2.carers.length > 0'>{{autobrand('translations.patient_B_has_carers_those_will_be_copied_to_chosen_patient')}}</li>
                    <li>{{autobrand('translations.differences_in_the_details_for_the_patient_records_are')}} <span style='border: 1px black solid; background-color: #ffe699;'>{{$t('translations.highlighted')}}</span> {{$t('translations.in_the_above_table')}}</li>

                </ul>
            </div>
            <div class="card mb-2">
                <div class="card-body">
                    <h4 class="card-title"><strong>{{autobrand('translations.keeping_patient_A')}}</strong></h4>
                    <p class="card-text">{{autobrand('translations.if_details_for_patient_A_correct_you_should_keep_Patient_A_merge_all_from_B_to_A_delete_B')}}</p>
                    <button class="btn btn-success btn-round mt-2" v-on:click.prevent='mergeUsers(item.user2.id, item.user1.id)' role="button">{{autobrand('translations.keep_patient_A')}}</button>
                </div>
            </div>

            <div class="card mb-2">
                <div class="card-body">
                    <h4 class="card-title"><strong>{{autobrand('translations.keeping_patient_B')}}</strong></h4>
                    <p class="card-text">{{autobrand('translations.if_details_for_patient_B_correct_you_should_keep_Patient_A_merge_all_from_A_to_B_delete_A')}}</p>
                    <button class="btn btn-success btn-round mt-2" v-on:click.prevent='mergeUsers(item.user1.id, item.user2.id)' role="button">{{autobrand('translations.keep_patient_B')}}</button>
                </div>
            </div>

        </div>

  </div>
</template>

<script>
	export default {
        props: [
            'item',
            'event'
        ],
        data: function() {
            return {
                rtl_loaded: 0
            };
        },
        computed: {
            rtl_diff() {
                if(this.rtl_loaded == 2) {
                    return ((this.$refs.user1_rtl.items.data.length + this.$refs.user2_rtl.items.data.length) > 0) ? "user_dup_diff" : "";
                }
            },
            user_1_has_rtl() {
                if(this.rtl_loaded == 2) {
                    return this.$refs.user1_rtl.items.data.length != 0;
                }
                return false;
            },
            user_2_has_rtl() {
                if(this.rtl_loaded == 2) {
                    return this.$refs.user2_rtl.items.data.length != 0;
                }
                return false;
            }
        },
        methods: {
            diff(value_1, value_2) {
                return (value_1 != value_2 ? "user_dup_diff" : "");
            },
            mergeUsers(from_id, to_id) {
                this.$modal.show('dialog', {
					title: this.autobrand('translations.merge_patients'),
					text: this.autobrand('translations.merge_patients_confirmation_text'),
					buttons: [
					{
						title: this.$t('translations.yes'),
						handler: () => {
							var data = {
                                from_id: from_id,
                                to_id: to_id
                            };
                            this.$modal.hide('dialog');
                            this.$parent.setLoading(true);
                            axios.post(this.$root.apiBase + '/patients/merge', data).then((res) => {
                                this.$parent.setLoading(false);
                                this.addNotification({type: "success", timeout: 20000, content: this.autobrand('translations.patient_records_have_been_merged'), route: {path: '/patient-list/patient-edit/' + to_id, text: this.autobrand('translations.edit_merged_patient_record')}});
                                console.log(res.data);
                                this.$parent.$parent.getResults();

                                this.$router.push({path: "/userduplicate-list"});

                            }).catch((error) => {
                                this.$parent.setLoading(false);
                                this.handleError(error, "merge");
                            });
						},
					},
					{
						title: this.$t('translations.cancel'),
						default: true
					}]});

            },
            getName() {
                return this.autobrand('translations.duplicate_patient_details');
            },
            openEditA(event) {
				this.$router.push({path: "/patient-list/patient-edit/" + this.item.user1.id });
			},
            openEditB(event) {
				this.$router.push({path: "/patient-list/patient-edit/" + this.item.user2.id });
			}


        }
    }
</script>